import React, { useState, useEffect, Fragment, useRef } from "react";
import { Dropdown } from "primereact/dropdown";
import { Calendar } from "primereact/calendar";
import { ProgressSpinner } from "primereact/progressspinner";
import { Ripple } from "primereact/ripple";
import { DataTable } from 'primereact/datatable';
import { Column } from 'primereact/column';
import { InputText } from 'primereact/inputtext';
import moment from "moment";
import { wglcsApiService } from "../../../services/WglcsApiService";
import EventEmitter, { Events } from "../../../services/eventemitter";
import _ from "lodash";
import { utils } from "../../../utils";
import { Skeleton } from 'primereact/skeleton';
import { t } from "i18next";
import "./DepartmentWiseChatReport.css";
import jsPDF from 'jspdf'
import 'jspdf-autotable'
import { DetectEnvironment } from "../../../EnvironmentSettings";
import ReactHTMLTableToExcel from 'react-html-table-to-excel';
import * as XLSX from 'xlsx';
import { Card } from "primereact/card";
import PieChart from "./PieChart";

const DepartmentWiseChatReport = () => {
    const tableRef = useRef(null);

    const fDate = new Date();
    fDate.setDate(fDate.getDate() - 5);
    // const tDate = new Date();
    // tDate.setDate(tDate.getDate() - 1);

    const [fromDate, setFromDate] = useState<any>(fDate);
    const [loading, setLoading] = useState(true);
    const [reportLoader, setReportLoader] = useState(false);
    const [websites, setWebsites] = useState<any>([{ id: 2, name: "temp" }]);
    const [selectedWebsite, setSelectedWebsite] = useState<any>(null);
    const [reportData, setReportData] = useState<any>([]);
    const [websiteId, setWebsiteId] = useState(0);
    const [toDate, setToDate] = useState<any>(new Date());
    const [minDate, setMinDate] = useState(new Date());
    const [maxDate, setMaxDate] = useState(new Date());
    const [BtnDisabled, setBtnDisabled] = useState(true);
    const [filterValue, setFilterValue] = useState("");
    const [filteredData, setFilteredData] = useState<any>([]);
    const [userWiseReport, setUserWiseReport] = useState<any>([]);

    useEffect(() => {
        EventEmitter.on(Events.passDataToChilds, onLoadWebsites);
        EventEmitter.emit(Events.requestForWebsiteData, "");

        return () => {
            EventEmitter.off(Events.passDataToChilds, onLoadWebsites);
        };
    }, []);

    const handleFromDate = (e) => {
        const fDate = moment(e.value).format("YYYY-MM-DD");
        setFromDate(fDate);
        setMinDate(e.value);
    };

    const handleToDate = (e) => {
        const tDate = moment(e.value).format("YYYY-MM-DD");
        setToDate(tDate);
    };

    const handleWebsite = (value) => {
        setSelectedWebsite(value);
        setWebsiteId(value.websiteId);
    };

    const onLoadWebsites = (data) => {
        if (!data?.loader) {
            const sortedWebsites = utils.arraySorting("domainName", data?.data);
            setWebsites([]);
            setWebsites(sortedWebsites);
            setLoading(false);
            setBtnDisabled(false);
            // setSelectedWebsite(sortedWebsites[0]);
            // setWebsiteId(sortedWebsites[0]?.websiteId);
            // getReportData(sortedWebsites[0]?.websiteId, fromDate, toDate);
        }

    };

    const getReportData = async (selectedWebsiteId, fromDate, toDate) => {
        if (selectedWebsiteId == undefined) {
            EventEmitter.emit(Events.DisplayApiErrorResponse, t('toast.website-validtion'))
            return;
        }

        setReportLoader(true)
        setFilteredData([1, 2, 3, 4])
        const fDate = moment(fromDate).format("YYYY-MM-DD");
        const tDate = moment(toDate).format("YYYY-MM-DD");

        const body = {
            fromDate: fDate,
            toDate: tDate,
            websiteId: selectedWebsiteId?.toString(),
            companyId: "",
        };

        const response = await wglcsApiService.departmentwisechatreport(body);
        if (response?.data?.status) {
            const totals = calculateTotals(response?.data?.data);
            const dataWithTotal = [...response?.data?.data, totals]; // Append the total row at the end

            const transformedData = response?.data?.data?.map(dept => ({
                departmentName: dept.departmentName,
                totalChats: dept.billableChats + dept.nonBillableChats + dept.closedChats
            }));



            setUserWiseReport(transformedData)
            setReportData(response?.data?.data)
            setFilteredData(dataWithTotal)
        }
        setReportLoader(false)
    };


    const calculateTotals = (data) => {

        const totalBillable = data.reduce((acc, curr) => acc + curr.billableChats, 0);
        const totalNonBillable = data.reduce((acc, curr) => acc + curr.nonBillableChats, 0);
        const totalClosed = data.reduce((acc, curr) => acc + curr.closedChats, 0);

        return {
            departmentName: "Total",
            billableChats: totalBillable,
            nonBillableChats: totalNonBillable,
            closedChats: totalClosed
        };
    };

    const onFilterValues = (value) => {
        setFilterValue(value)
        const filtered = reportData?.filter(item =>
            item.departmentName.toLowerCase().includes(value.toLowerCase())
        );

        if (filtered?.length > 0) {
            const totals = calculateTotals(filtered);
            const dataWithTotal = [...filtered, totals];

            setFilteredData(dataWithTotal);
        }
        else {
            setFilteredData(filtered);
        }
    }

    // Export the report data to PDF
    const exportToPDF = () => {
        const doc = new jsPDF() as any;
        const pdfWidth = doc.internal.pageSize.getWidth();
        const logoWidth = 45;
        const logoHeight = 15;
        const logoY = 5;
        const centerX = (pdfWidth - logoWidth) / 2;

        const imageElement = document.getElementById('logoImage');
        const canvas = document.createElement('canvas');
        const ctx = canvas.getContext('2d');
        ctx?.drawImage((imageElement as any), 0, 0, canvas.width, canvas.height);
        const imgData = canvas.toDataURL('image/svg');
        doc.addImage(imgData, 'SVG', centerX, logoY, logoWidth, logoHeight);

        doc.setFontSize(12);
        const text = "Department Wise Chat Report";
        const textWidth = doc.getStringUnitWidth(text) * doc.internal.getFontSize() / doc.internal.scaleFactor;
        const textX = (pdfWidth - textWidth) / 2;
        doc.text(text, textX, 35);
        doc.text(52, 42, exportSelectedWebsite())
        const headers = [["Department Name", "Billable Chats", "Non-Billable Chats", "Closed Chats"]];
        const data = filteredData.map(item => [
            item.departmentName,
            item.billableChats,
            item.nonBillableChats,
            item.closedChats
        ]);

        const tableProps = {
            startY: 48,
            head: headers,
            body: data,
            headStyles: {
                fontSize: 10, // Adjust the font size
                fontStyle: 'normal', // Set fontStyle to 'normal' for regular text
                fillColor: [78, 134, 199], // Header background color
                textColor: 255, // Header text color
                cellPadding: 1, // Padding of header cells
                lineColor: [0, 0, 0], // Lines between header cells
                halign: 'center'
            },
            bodyStyles: { fontSize: 8, cellPadding: 1, halign: 'center' },
            columnStyles: {
                0: { cellWidth: 60 },
                1: { cellWidth: 40 },
                2: { cellWidth: 40 },
                3: { cellWidth: 40 },
            }
        };

        doc.autoTable(tableProps);
        doc.save("DepartmentWiseChatReport.pdf");
    };


    const renderLoader = () => (
            <ProgressSpinner strokeWidth="3" fill="#EEEEEE" style={{ height: "20px", width: "20px" }} animationDuration=".5s" />
    
    );

    const cellTemplate = (rowData, field) => {
        if (reportLoader) {
            // Render skeleton when data is still loading
            return <Skeleton width="100%" height="1.5rem" />;
        }

        return (
            <span style={{ fontWeight: rowData.departmentName === "Total" ? 'bold' : 'normal' }}>
                {rowData[field]}
            </span>
        );
    };

    const exportSelectedWebsite = () => {
        if (selectedWebsite) {
            return selectedWebsite?.domainName + " " + "(" + t('From') + ":" + moment(fromDate).format("MM-DD-YYYY") + " " + t("To") + ":" + moment(toDate).format("MM-DD-YYYY") + ")"
        } else {
            return ""
        }
    }

    return (
        <Fragment>
            <img id="logoImage" src={process.env.PUBLIC_URL + "/image/" + DetectEnvironment.config.REACT_APP_LOGO} alt="" style={{ display: 'none' }} />
            <div className="row p-2">
                <div className="wgreport-tab viewreport-box py-2">
                    <div className="row view-wgreport ">
                        <div className="col-md-3 py-1 wgreport" >
                            <label className="wgreport-label" htmlFor="basic">{t('MonitoringPanel 6erComponent.Website-Name')}</label>
                            <div className="spinner-box">
                                <Dropdown className="form-control"
                                    filter
                                    showFilterClear
                                    filterBy="domainName"
                                    value={selectedWebsite}
                                    options={websites}
                                    onChange={(e) => handleWebsite(e.target.value)}
                                    optionLabel="domainName"
                                    placeholder={loading ? "" : t("ReportComponent.Select Website")}
                                />
                                {loading && renderLoader()}
                            </div>
                        </div>

                        <div className="col-md-2  py-1 wgreport" >
                            <label className="wgreport-label" htmlFor="firstname6">{t('ChatTranscriptComponent.From Date')}</label>
                            <Calendar
                                showIcon
                                value={fromDate}
                                onChange={handleFromDate}
                                monthNavigator
                                yearNavigator
                                yearRange="2000:2050"
                                maxDate={maxDate}
                            />
                        </div>

                        <div className="col-md-2 py-1 wgreport">
                            <label className="wgreport-label" htmlFor="basic">{t('ChatTranscriptComponent.To Date')}</label>
                            <Calendar id="abc"
                                showIcon
                                value={toDate}
                                onChange={handleToDate}
                                minDate={minDate}
                                maxDate={maxDate}
                                monthNavigator
                                yearNavigator
                                yearRange="2000:2050"
                            />
                        </div>

                        <div className="col-md-5 py-1 text-right text-md-left">
                            {(reportData?.length > 0 && selectedWebsite != null) &&
                                <>
                                    <ReactHTMLTableToExcel
                                        id="test-table-xlsx-button search-btn"
                                        className="search-btn wgbtn p-ripple"
                                        table="table-to-xlsx"
                                        filename={"Department Wise Chat Report"}
                                        sheet={'DepartmentWiseChatReport'}
                                        buttonText={t('wg-buttons.Export-Excel')}
                                    />
                                    <button title={t('wg-buttons.Export-PDF')} className="search-btn wgbtn p-ripple" onClick={() => exportToPDF()}> <Ripple />{t('wg-buttons.Export-PDF')}</button>

                                </>}
                            <button
                                // disabled={selectedWebsite == null ? true : false}
                                className="search-btn wgbtn p-ripple"
                                onClick={() => getReportData(selectedWebsite?.websiteId, fromDate, toDate)}
                                title={t('wg-buttons.View-Report')}
                            >
                                {t('wg-buttons.View-Report')}
                            </button>

                        </div>
                    </div>
                </div>
            </div>


            <div className="row">
                <div className="col-md-12 text-right">
                    <div className="search-view">
                        <InputText
                            className="searchfeild"
                            placeholder="Search"
                            value={filterValue}
                            onChange={(e) => onFilterValues(e.target.value)}
                        // placeholder="Filter by Department Name"
                        />
                        <i className="fa-light fa-search search-icon"></i>

                    </div>
                </div>
            </div>

            <DataTable value={filteredData}>
                <Column
                    field="departmentName"
                    header={t("DepartmentWiseChatReport.dept-name")}
                    body={(rowData) => cellTemplate(rowData, 'departmentName')}
                />
                <Column
                    field="billableChats"
                    header={t("DepartmentWiseChatReport.Billable Chats")}
                    body={(rowData) => cellTemplate(rowData, 'billableChats')}
                />
                <Column
                    field="nonBillableChats"
                    header={t("DepartmentWiseChatReport.Non-Billable Chats")}
                    body={(rowData) => cellTemplate(rowData, 'nonBillableChats')}
                />
                <Column
                    field="closedChats"
                    header={t("DepartmentWiseChatReport.Closed Chats")}
                    body={(rowData) => cellTemplate(rowData, 'closedChats')}
                />
            </DataTable>


            <div className='htmltable' style={{ display: 'none' }}>
                {filteredData && <table id="table-to-xlsx" ref={tableRef}>
                    <thead>
                        <tr>
                            <td>&nbsp;</td>
                        </tr>
                        <tr>
                            <td>&nbsp;</td>
                            <td style={{ fontSize: "18px", color: "black", textAlign: "center", fontWeight: 600 }} colSpan={7}>{t("DashboardReports.DepartmentWiseChatReport")}</td>
                        </tr>
                        <tr>
                            <td>&nbsp;</td>
                            <th style={{ fontSize: "16px", color: "black", textAlign: "center", fontWeight: 400 }} colSpan={7}>{exportSelectedWebsite()}</th>
                        </tr>
                        <tr>
                            <td>&nbsp;</td>
                        </tr>
                    </thead>
                    <tbody>
                        <tr>
                            <th>&nbsp;</th>
                            <th>&nbsp;</th>
                            <th>&nbsp;</th>
                            <th style={{ background: "#84bdf3", border: "1px solid #000" }}>
                                Department Name
                            </th>
                            <th style={{ background: "#84bdf3", border: "1px solid #000" }}>
                                Billable Chats
                            </th>
                            <th style={{ background: "#84bdf3", border: "1px solid #000" }}>
                                Non-Billable Chats
                            </th>
                            <th style={{ background: "#84bdf3", border: "1px solid #000" }}>
                                Closed Chats
                            </th>
                        </tr>
                        {filteredData?.map((item, index) => (
                            <tr key={index}>
                                <td>&nbsp;</td>
                                <td>&nbsp;</td>
                                <td>&nbsp;</td>
                                <td style={{ textAlign: "center", border: "1px solid #000" }}>{item.departmentName}</td>
                                <td style={{ textAlign: "center", border: "1px solid #000" }}>{item.billableChats}</td>
                                <td style={{ textAlign: "center", border: "1px solid #000" }}>{item.nonBillableChats}</td>
                                <td style={{ textAlign: "center", border: "1px solid #000" }}>{item.closedChats}</td>
                            </tr>
                        ))}
                    </tbody>
                </table>}
            </div>


            {<PieChart data={userWiseReport} heading={t("DepartmentWiseChatReport.Department-heading")} />}
        </Fragment >
    );
};

export default DepartmentWiseChatReport;
